import {inject, Inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {APIService} from "./api.service";
import {ICreateBroadcastNotification} from "../interfaces/notifications/ICreateBroadcastNotification";
import {IBroadcastNotification} from "../interfaces/notifications/IBroadcastNotification";
import {IApiResponseBase} from "../interfaces/IApiResponseBase";

@Injectable({
  providedIn: 'root'
})
export class BroadcastNotificationService
{
  private apiService: APIService = inject(APIService)

  public createBroadcastNotification(createBroadcastNotificationP: ICreateBroadcastNotification): Observable<IApiResponseBase> {
    return this.apiService.MakePostRequest<IApiResponseBase>('broadcast-notification/create', createBroadcastNotificationP);
  }

  public getBroadcastNotification(id: string, gameId?: string): Observable<IBroadcastNotification> {
    return this.apiService.MakeGetRequest<IBroadcastNotification>(`broadcast-notification/${id}${gameId ? `?gameId=${gameId}` : ''}`);
  }

  public updateBroadcastNotification(id: string, updateBroadcastNotificationP: ICreateBroadcastNotification): Observable<IApiResponseBase> {
    return this.apiService.MakePutRequest<IApiResponseBase>(`broadcast-notification/update/${id}`, updateBroadcastNotificationP);
  }

  public getAllBroadcastNotifications(): Observable<IBroadcastNotification[]> {
    return this.apiService.MakeGetRequest<IBroadcastNotification[]>('broadcast-notification/all');
  }

  public getBroadcastNotificationsByGameId(gameId: string): Observable<IBroadcastNotification[]> {
    return this.apiService.MakeGetRequest<IBroadcastNotification[]>(`broadcast-notification/game/${gameId}`);
  }
}
